import { AppState } from "features";

export const getState = (state: AppState) => state;
